<template>

    <div class="error">
        <div class="info">
            ERROR OCCURED TRY AGAIN
        </div>
    </div>

</template>

<script>
    export default {
        name: 'default-error'
    }
</script>

<style lang="scss" scoped>
    .error{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 88888;
        opacity: 0.8;
        background: black;
        -webkit-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.8);
        -moz-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.8);
        box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.8);

        .info{
            color: #FF4136;
            text-align: center;
            font-size: 4rem;
            position: fixed;
            top: 350px;
            right: 0;
            left: 0;
            margin: auto;
        }
    }
</style>